import { render, staticRenderFns } from "./StatusPedidos.vue?vue&type=template&id=5a68fcff&scoped=true&"
import script from "./StatusPedidos.vue?vue&type=script&lang=js&"
export * from "./StatusPedidos.vue?vue&type=script&lang=js&"
import style0 from "./StatusPedidos.vue?vue&type=style&index=0&id=5a68fcff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a68fcff",
  null
  
)

export default component.exports